import React, { useState } from "react";

const AddUser = () => {
  const [form, setForm] = useState({
    name: "",
    surname: "",
    email: "",
    password: "",
    phone: "",
    role: "1",
    file: null,
  });

  const roles = [
    { id: 1, name: "User" },
    { id: 2, name: "IKT" },
    { id: 3, name: "Admin" },
  ];

  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");

  // SUCCESS POPUP STATE
  const [successMsg, setSuccessMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "email") {
      setEmailError("");
    }
  };

  const handleSubmit = async () => {
    setLoading(true);

    const data = new FormData();

    data.append("name", form.name);
    data.append("surname", form.surname);
    data.append("email", form.email);
    data.append("password", form.password);
    data.append("phone", form.phone);
    data.append("role", form.role);

    if (form.file) {
      data.append("file", form.file);
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/addUser.php`, {
        method: "POST",
        body: data,
      });

      const text = await res.text();

      let result;
      try {
        result = JSON.parse(text);
      } catch (e) {
        alert("Server error");
        return;
      }

      if (result.success) {
        setSuccessMsg("✔ Uporabnik uspešno dodan!");

        setTimeout(() => setSuccessMsg(""), 3000);

        setForm({
          name: "",
          surname: "",
          email: "",
          password: "",
          phone: "",
          role: "1",
          file: null,
        });

        setEmailError("");
      } else {
        if (result.message === "EMAIL_EXISTS") {
          setEmailError("Uporabnik z tem E-mail naslovom že obstaja");
        } else {
          alert(result.message || "Napaka pri dodajanju userja");
        }
      }
    } catch (err) {
      alert("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-50 p-5 m-2 rounded-2xl relative">
      {/* SUCCESS POPUP */}
      {successMsg && (
        <div className="fixed top-5 left-1/2 -translate-x-1/2 bg-green-600 text-white px-6 py-3 rounded-xl shadow-lg z-50">
          {successMsg}
        </div>
      )}

      <h1 className="text-3xl font-bold mb-5">Dodaj uporabnika</h1>

      <div className="bg-white rounded-2xl shadow p-6 space-y-4">
        <input
          name="name"
          placeholder="Ime"
          value={form.name}
          onChange={handleChange}
          className="w-full border p-3 rounded-xl"
        />

        <input
          name="surname"
          placeholder="Priimek"
          value={form.surname}
          onChange={handleChange}
          className="w-full border p-3 rounded-xl"
        />

        <input
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          className="w-full border p-3 rounded-xl"
        />

        {emailError && (
          <p className="text-red-500 text-sm mt-1 ml-1">{emailError}</p>
        )}

        <input
          name="password"
          type="password"
          placeholder="Začasno geslo"
          value={form.password}
          onChange={handleChange}
          className="w-full border p-3 rounded-xl"
        />

        <input
          name="phone"
          placeholder="Telefon"
          value={form.phone}
          onChange={handleChange}
          className="w-full border p-3 rounded-xl"
        />

        <select
          name="role"
          value={form.role}
          onChange={handleChange}
          className="w-full border p-3 rounded-xl"
        >
          {roles.map((r) => (
            <option key={r.id} value={r.id}>
              {r.name}
            </option>
          ))}
        </select>

        <button
          type="button"
          onClick={handleSubmit}
          disabled={loading}
          className="bg-midBlue text-white px-6 py-3 rounded-xl font-bold hover:bg-primary"
        >
          {loading ? "Dodajam..." : "Dodaj uporabnika"}
        </button>
      </div>
    </div>
  );
};

export default AddUser;
